import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TCustomsDutyRate } from 'redux/reducers/taxDuties/types';

export const tableStructure: TTableStructure<keyof TCustomsDutyRate>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
		key: true,
	},
	{
		name: 'Country Id',
		selector: 'countryId',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Country',
		selector: 'originCode',
		show: true,
		sortable: true,
		filterable: true,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.COUNTRY,
		align: ETableStructureAlign.LEFT,
		// countryOptions: {
		// 	showName: true,
		// 	filterBy: 'number',
		// } as TCountryOptions,
	},
	{
		name: 'HS6+ Code',
		selector: 'hs6pCode',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Customs Duty',
		selector: 'customsDuty',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		currency: () => '%',
	},
	{
		name: 'Measure Type',
		selector: 'measureType',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Measure Type Code',
		selector: 'measureTypeCode',
		show: false,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Legal Base',
		selector: 'legalBase',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Description',
		selector: 'description',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Start Date',
		selector: 'startDate',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'End Date',
		selector: 'endDate',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Update',
		selector: 'timestamp',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
];
